import { defineMessages, FormattedMessage, useIntl } from 'react-intl'
import AdventuresSlider from './AdventuresSlider'
import { getActivitesByType } from './hooks'

const messages = defineMessages({
  'dive-trips': {
    id: 'explore.empty.section.diveTrips',
    defaultMessage: 'No bookable dive trips here!',
  },
  courses: {
    id: 'explore.empty.section.courses',
    defaultMessage: 'No bookable courses here!',
  },
  snorkelling: {
    id: 'explore.empty.section.snorkelling',
    defaultMessage: 'No bookable snorkelling trips here!',
  },
  conservation: {
    id: 'explore.empty.section.conservation',
    defaultMessage: `We couldn't find any activities near you`,
  },
})

export default function AdventureExploration({
  coords,
  sectionTitle,
  type,
  link,
  params,
}) {
  const intl = useIntl()
  const { isLoading, items } = getActivitesByType(type, coords, params)

  return (
    <div className='adventure-slider'>
      {sectionTitle && (
        <h2 className='homepage-section__title'>{sectionTitle}</h2>
      )}
      {isLoading || items.length ? (
        <AdventuresSlider
          items={items}
          isLoading={isLoading}
          isConservation={type === 'conservation'}
        />
      ) : (
        <div className='no-results'>{intl.formatMessage(messages[type])}</div>
      )}
      {link && (
        <a href={link} className='btn-guides-blue'>
          <FormattedMessage id='view_all' defaultMessage='View all' />
        </a>
      )}
    </div>
  )
}
